/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import "./styles.scss";

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'tip';

/**
 * This is the component description.
 */
const Tip = ({
  id,
  className: userClassName,
  style,
  children,
  icon,
  as: Wrapper,
  color,
  backgroundColor
  // ...otherProps
}) => /*#__PURE__*/React.createElement(Wrapper, {
  id: id,
  className: [baseClassName, componentClassName, userClassName, `x-${backgroundColor}`].filter(e => e).join(' '),
  style: style
  // {...otherProps}
}, /*#__PURE__*/React.createElement("span", {
  className: `x-${color} c-x icon`
}, icon), children);
Tip.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The children jsx
   */
  children: PropTypes.node.isRequired,
  /**
   * The icon
   */
  icon: PropTypes.string,
  /**
   * The color of the icon
   */
  color: PropTypes.string,
  /**
   * The background color
   */
  backgroundColor: PropTypes.string,
  /**
   * The wrapper html type
   */
  as: PropTypes.string
};
Tip.defaultProps = {
  as: 'p',
  icon: ')',
  color: 'interactive',
  backgroundColor: 'background-near'
};
export default Tip;